export default __webpack_public_path__ + "static/media/Inter-SemiBold.25b1ffc9.woff";